import { addMinutes, format } from 'date-fns';

/** CreateJobModal stores a local wall clock. flatpickr minDate uses the same string. */
const PWA_PICKER_DATE_FORMAT = 'yyyy-MM-dd HH:mm';
const PWA_APPOINTMENT_LEAD_MS = 24 * 60 * 60 * 1000;

/**
 * Now + 24 real hours, rounded up to the picker 15-minute mark, seconds dropped.
 * Leftover seconds or milliseconds advance to the next mark, including when the
 * minute is already divisible by 15. An exact :00.000 on a mark stays put.
 * Mirrors techrepair-glass-shop earliestShopAppointment.
 */
export function earliestPwaAppointment(now: Date = new Date()): Date {
    const lead = new Date(now.getTime() + PWA_APPOINTMENT_LEAD_MS);
    const minuteRemainder = lead.getMinutes() % 15;
    const hasSubminute = lead.getSeconds() !== 0 || lead.getMilliseconds() !== 0;
    const minutesUp = minuteRemainder === 0 ? (hasSubminute ? 15 : 0) : 15 - minuteRemainder;
    const rounded = addMinutes(lead, minutesUp);
    rounded.setSeconds(0, 0);
    return rounded;
}

export function earliestPwaAppointmentString(now: Date = new Date()): string {
    return format(earliestPwaAppointment(now), PWA_PICKER_DATE_FORMAT);
}
